import { FlowType, Sex } from '@/types-aggregatore';

export enum SortingListingType {
  distanceAsc = 'DISTANCE_ASC',
  priceAsc = 'PRICE_ASC',
  firstAvailabilityAsc = 'FIRST_AVAILABILITY_ASC',
  noDistinct = 'NO_DISTINCT',
}

export enum ChannelFilterType {
  online = 'ONLINE',
  onsite = 'ONSITE',
  domiciliary = 'DOMICILIARY',
}

export enum DateFilterType {
  three_days = 'THREE_DAYS',
  seven_days = 'SEVEN_DAYS',
}

export enum PaymentFilterType {
  online = 'ONLINE',
  onsite = 'ONSITE',
}

export type FilterProps = {
  specialization?: string;
  license?: string;
  excludeOnline?: boolean;
  excludeOnsite?: boolean;
  excludeDomicilary?: boolean;
  ambulatoryId?: string;
  groupSlug?: string;
  dateFilter?: DateFilterType;
  channel?: ChannelFilterType[];
  doctorSex?: Sex;
  paymentType?: PaymentFilterType;
  availableFlowTypes?: FlowType;
  excludePrice0?: boolean;
};
